export default __webpack_public_path__ + "formulario3.jpg";